export default {
  dsimLogin: {
    title: '账号登录',
    userName: '用户名',
    password: '密码',
    log: '登录',
    resiger: '注册',
    ruleEmail: '请输入用户名',
    rulePwd: '请输入密码',
    logSucess: '登录成功',
    companyAccount: '用户名',
    logPwdError: '账号或密码错误,请重新输入',
    noResiger: '此用户没有注册，暂时无法登陆'
  },
  dsimResiger: {
    title: 'DSIM账号注册',
    userName: '姓名',
    telephone: '电话',
    companyName: '单位名称',
    email: '邮箱',
    password: '密码',
    confirmPassword: '确认密码',
    forgetPwd: '忘记密码',
    log: '确定',
    ruleUserName: '请输入姓名',
    ruleTelephone: '请输入电话',
    ruleCompanyName: '请输入单位名称',
    rulePwd: '请输入密码',
    confirmAgainPassWord: '请再次输入密码',
    noTwoPassWord: '两次密码不一致，请重新输入',
    ruleEmail: '请输入邮箱',
    ruleTrueEmail: '请输入正确的邮箱',
    resigerSuccess: '注册成功'
  },
  licenseManager: {
    selectFont: '请选择',
    manageTitle: '管理',
    userNameSearch: '按姓名搜索',
    emailSearch: '按邮箱搜索',
    companySearch: '按单位名称搜索',
    licenseIdSearch: '按licenseId搜索',
    typeSearch: '按类型搜索',
    groupSearch: '按用户组搜索',
    userName: '姓名',
    telephone: '电话',
    licenseStartTime: '开始时间',
    licenseEndTime: '结束时间',
    companyAccount: '企业账号',
    companyName: '单位名称',
    email: '邮箱',
    licenseTypeName: '类型',
    userGroupName: '用户组',
    operation: '操作',
    downLoad: '下载license',
    add: '添加',
    manger: '管理',
    modify: '修改',
    delete: '删除',
    show: '登录信息查看',
    showActive: '在线人数'
  },
  licenseShow: {
    userName: '姓名',
    loginTime: '登录时间',
    logoutTime: '退出时间',
    userShowList: '用户使用信息'
  },
  licenseUserShow: {
    userName: '账号'
  },
  lincenceAdd: {
    versionInfo: '版本信息',
    ruleVersionInfo: '请输入版本信息，例如：1.00、2.10、3.43',
    userName: '姓名',
    telephone: '电话',
    companyName: '单位名称',
    email: '邮箱',
    password: '密码',
    machineCode: '机器码',
    licenseType: '类型',
    userGroup: '用户组',
    licenseStartTime: '开始时间',
    licenseEndTime: '结束时间',
    licenceEffectiveTime: '有效时间',
    licenceMaintenancePeriod: '维护期',
    companyAccount: '企业账号',
    userCount: '最大在线计算机数量',
    serverAddress: '服务器地址',
    moreCode: '多个请用逗号隔开',
    codeTipOne: '只能输入一个机器码',
    codeTipTwo: '最多只能输入两个机器码',
    save: '保存',
    close: '关闭',
    ruleUserName: '请输入姓名',
    ruleTelephone: '请输入电话',
    ruleCompanyName: '请输入单位名称',
    ruleEmail: '请输入邮箱',
    rulePwd: '请输入密码',
    ruleMachineCode: '请输入机器码',
    ruleLicenseType: '请输入类型',
    ruleUserGroup: '请输入用户组',
    ruleLicenseStartTime: '请选择开始日期',
    ruleLicenseEndTime: '请选择有效日期',
    ruleLicenceEffectiveTime: '请输入有效时间',
    ruleLicenceMaintenancePeriod: '请选择维护期',
    ruleCompanyAccount: '请输入企业账号',
    ruleLicenceUserCount: '请输入最大在计算机数量',
    ruleServiceAddress: '请输入服务器IP地址',
    ruleTrueServiceAddress: '请输入正确的IP地址',
    licenseType1: '社区版',
    licenseType2: '单机版（离线）',
    licenseType3: '网络版（广域网）',
    licenseType4: '网络版（局域网）',
    licenseType5: '硬件版(单机)',
    licenseType6: '硬件版(网络)',
    licenseType7: '单机版',
    group1: '社区版用户',
    group2: '试用用户',
    group3: '基础版用户',
    group4: '专业版用户',
    group5: '企业版用户',
    group6: '开发者',
    addTitle: '添加账号',
    modifyTitle: '修改账号'
  },
  companyLogin: {
    title: '企业管理员登录',
    companyAccount: '企业账号',
    password: '密码',
    log: '登录',
    ruleCompanyAccount: '请输入企业账号',
    rulePwd: '请输入密码'
  },
  companyUserInfo: {
    userAccount: '账号',
    userName: '用户名',
    userDesc: '用户描述',
    machineCode: '机器码',
    password: '密码',
    licenseTypeName: '类型',
    userGroupName: '用户组',
    loginTime: '登录时间',
    add: '添加',
    modify: '修改',
    delete: '删除',
    refresh: '刷新',
    ruleUserAccount: '请输入账号',
    ruleUserName: '请输入用户名',
    rulePwd: '请输入密码',
    ruleCode: '请输入机器码',
    addAccount: '添加账号',
    modifyAccount: '修改账号'
  },
  commentData: {
    selectFont: '请选择',
    selectDate: '请选择日期',
    selectDeleteData: '请选择要删除的数据',
    selectModifyData: '请选择要修改的数据',
    addSucess: '添加成功',
    modifySucess: '修改成功',
    addFail: '添加失败',
    modifyFail: '修改失败',
    noLoginTip: '请先登录',
    noModify: '社区版暂时无法修改',
    noData: '暂无数据',
    loginSuccess: '登录成功',
    modifySuccess: '修改成功，请重新登录',
    noAddInfo: '超过限制的电脑数量，不允许再添加',
    reset: '重置',
    resigerSuccess: '注册成功',
    type7DeleteData: '激活的电脑不可以删除',
    type7EditeData: '激活的电脑不可以修改'
  },
  navbar: {
    logOut: '退出登录',
    pageTitle: 'DSIM权限管理系统'
  },
  route: {
    accountManager: '账号分配',
    personInfo: '个人中心',
    fileUpload: '版本管理'
  },
  personInfo: {
    modifyPwd: '修改密码',
    nowPassWord: '当前密码',
    newPassWord: '新密码',
    confirmPassWord: '确认密码',
    nowRulePassWord: '请输入当前密码',
    newRulePassWord: '请输入新密码',
    confirmRulePassWord: '请输入确认密码',
    nowErrorPassWord: '当前密码不正确',
    confirmAgainPassWord: '请再次输入密码',
    noTwoPassWord: '两次密码不一致，请重新输入',
    userCode: '邮箱验证码',
    sendUserCode: '发送邮箱验证码',
    newRuleUserCode: '请输入邮箱验证码'
  },
  deleteObj: {
    title: '确定要删除吗？',
    tip: '提示',
    confirm: '确定',
    quit: '取消',
    success: '删除成功',
    fail: '删除失败'
  },
  dsimDeleteOnj: {
    title: '删除企业账号的同时，子账号也会被删除，确定要删除吗？',
    titleTwo: '确定要删除吗？'
  },
  modifyObj: {
    title: '确定要修改吗？',
    tip: '提示',
    confirm: '确定',
    quit: '取消',
    success: '修改成功',
    fail: '修改失败'
  },
  addObj: {
    title: '确定要添加吗？',
    tip: '提示',
    confirm: '确定',
    quit: '取消',
    success: '添加成功',
    fail: '添加失败'
  },
  logoutObj: {
    title: '确定要退出登录吗？',
    tip: '提示',
    confirm: '确定',
    quit: '取消'
  },
  version: {
    title: '版本管理',
    tip: '将文件拖放到此处上传或',
    number: '版本号',
    selectFile: '选择文件',
    selectFolder: '选择文件夹',
    success: '成功了',
    error: '出错了',
    uploading: '上传中',
    paused: '暂停中',
    waiting: '等待中',
    uploadSucess: '上传成功',
    uploadFail: '上传失败'
  },
  enterpriseManager: {
    company: '公司',
    code: '许可证编号',
    total: '最大在线计算机数量',
    onlineTotal: '最大在线计算机数量',
    coded: '已在线计算机数量',
    onlineCoded: '已在线计算机数量',
    searchName: '按姓名搜索',
    num: '序列号'
  },
  enterpriseManagerAdd: {
    addTitle: '添加账号',
    modifyTitle: '修改账号',
    number: '序列号',
    info: '用户名',
    status: '状态',
    valid: '有效',
    invalid: '无效',
    password: '密码',
    total: '最大在线计算机数量',
    totaled: '在线计算机数量',
    period: '许可证周期',
    day: '天',
    setExpiry: '根据下次激活的时间和许可证周期设定失效日期',
    absoluteDate: '绝对失效期',
    computerList: '计算机列表',
    activities: '显示活动信息',
    ruleInfo: '请输入用户名',
    rulePassword: '请输入密码',
    ruleTotal: '请输入最大在线计算机数量',
    ruleTotaled: '请输入已在线计算机数量',
    automaticLogonSetting: '自动注册设置',
    automaticLogon: '自动注册',
    userDesc: '用户描述',
    autoRegisterNum: '自动注册数量'
  },
  computerObj: {
    number: '序列号',
    user: '用户',
    des: '描述',
    computerId: '计算机ID',
    activeDate: '激活日期',
    expiryDate: '失效日期',
    loginTime: '登录时间',
    logoutTime: '退出时间',
    machineCode: '机器码',
    computerDes: '计算机描述',
    ruleMachineCode: '请输入机器码',
    save: '保存',
    cancel: '取消',
    close: '关闭'
  },
  resetPwd: {
    title: 'DSIM密码重置',
    stepOne: '邮箱验证',
    stepTwo: '密码重置',
    stepThree: '重置完成',
    nextStep: '下一步',
    resetSucess: '密码重置成功'
  },
  emailActive: {
    title: '感谢注册！激活邮件已发送至您的注册邮箱',
    '30min': '请您在30分钟内进入邮箱完成激活，以便于dsim使用',
    tips: '没有收到邮件',
    tip1: '请检查邮箱地址是否填写正确，可以返回',
    fillAgain: '重新填写',
    tip2: '检查您的邮件垃圾箱',
    tip3: '若仍未收到激活邮件，请尝试',
    sendAgain: '重新发送',
    sendSuccess: '发送成功',
    goBack: '返回首页',
    goEmail: '前往邮箱'
  },
  registerSuccess: {
    goBack: '返回首页',
    title: '恭喜您，注册成功！',
    nowuse: '欢迎使用dsim权限管理系统'
  },
  versionManager: {
    version: '版本',
    publishFlag: '发布状态',
    publishTime: '发布时间',
    uploadTime: '上传时间',
    operation: '操作',
    manger: '管理',
    add: '添加',
    modify: '修改',
    delete: '删除',
    refresh: '刷新',
    ruleVersion: '请输入版本号',
    addTitle: '添加版本',
    modifyTitle: '修改版本',
    publish: '已发布',
    unPublish: '未发布',
  },
  errorCode: {
    '401': '认证失败，无法访问系统资源',
    '403': '当前操作没有权限',
    '404': '访问资源不存在',
    'default': '系统未知错误，请反馈给管理员',
    '401tips': '登录状态已过期，您可以继续留在该页面，或者重新登录',
    '401title': '系统提示',
    relogin: '重新登录',
    stay: '留在页面',
    networkError: '后端接口连接异常',
    timeout: '系统接口请求超时',
    requestFailed1: '系统接口',
    requestFailed2: '异常',
    companyIsResiger:'该企业帐号已被注册，请更换',
    emailIsResiger:'该邮箱已被注册，请更换',
    infoIsNull:'登录用户获取失败，请重新登录或联系管理员',
    noPermission:'登录用户无权限，请联系管理员',
    oldPasswordIsWrong:'旧密码不正确',
    emailSendError:'激活邮件发送失败，请稍后再试',
    userCodeWrong:'验证码错误',
    userCodeInForce:'验证码未过期',
    repetActice:'已是激活状态，无需重复激活',
    userCodeExpriy:'激活超时，重新发送验证码',
    getLicenseError:'获取license信息异常，请联系管理员',
    operationFailed:'操作失败',
    machineCodeIsSame:'该账户下已有相同机器',
    companyUnResiger:'帐号未注册，请重新输入',
    accountOrPasswordWrong:'账号或密码错误,请重新输入',
    accountOutOfDate:'企业账户未在有效期内，不允许登录，请联系管理员',
    userNameIsSame:'该企业下有同名用户，请修改',
    haveSubusers: '该账号下有子账号，无法删除，请先删除子账号',
    haveComputer: '该账号下有计算机，无法删除，请先删除计算机',
    computerIsActive: '激活状态的计算机无法删除'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js